// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';

import App from './App';
import { AuthProvider } from './AuthContext';
import './index.css';

Amplify.configure({
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_AWS_REGION || 'eu-west-3',
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'eu-west-3_ZGOkfyRY4',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || 'qt94p1ksl5n9gm3nf9n4g2872',
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);